import { AuxiliumComponent } from "../auxilium-component";

export default class DropdownGroup extends AuxiliumComponent {
	static observable = ["label", "size"];

	constructor() {
		super();

		this.size ??= "5";
	}

	parsedCallback() {
		this.appendChild(document.createElementWithContents("chip-header", this.label, { size: this.size }));
	}
}
